import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faBarcode,
  faClone,
  faLevelUpAlt,
  faShareSquare,
  faWarehouse,
  faCalculator,
  faChevronCircleLeft,
  faSync,
  faUserCheck,
  faFileImport,
  faCircle,
  faHistory,
  faClock,
  faFileInvoice,
  faPercent,
  faPrint,
  faBroom,
  faLink,
  faEdit,
  faCompass,
  faTrash,
  faSortDown,
  faSortUp,
  faUserCircle,
  faUserPlus,
  faArrowLeft,
  faPlus,
  faExternalLinkAlt,
  faTimes,
  faKey,
  faInfo,
  faCalendarAlt,
  faCheck,
  faFlagUsa,
  faEnvelope,
  faLongArrowAltRight,
  faStickyNote,
  faStopwatch,
  faChevronLeft,
  faAddressCard,
  faChevronRight,
  faChevronDown,
  faTable,
  faChevronUp,
  faDollarSign,
  faFileExport,
  faSave,
  faArrowRight,
  faFilter,
  faRoute,
  faCog,
  faFax,
  faSpinner,
  faBookOpen,
  faCogs,
  faBars,
  faLock,
  faSignOutAlt,
  faCertificate,
  faUser,
  faMinus,
  faFlag,
  faMoneyBill,
  faSearch,
  faAngleDown,
  faGlobe,
  faBan,
  faBinoculars,
  faAngleLeft,
  faAngleRight,
  faPencilAlt,
  faUpload,
  faBold,
  faArchive,
  faItalic,
  faTruck,
  faBalanceScale,
  faExclamation,
  faPhone,
  faPhoneAlt,
  faUsers,
  faUnderline,
  faUndo,
  faExclamationCircle,
  faMapPin,
  faBalanceScaleRight,
  faHome,
  faCalendar,
  faAddressBook,
  faMapMarkerAlt,
  faFileInvoiceDollar,
  faUsersCog,
  faWeightHanging,
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCogs,
  faFileInvoiceDollar,
  faExclamation,
  faMapMarkerAlt,
  faAngleDown,
  faRoute,
  faArrowRight,
  faBalanceScaleRight,
  faArrowLeft,
  faExclamationCircle,
  faMapPin,
  faBalanceScale,
  faCog,
  faAngleLeft,
  faAngleRight,
  faFax,
  faTruck,
  faArchive,
  faHome,
  faBold,
  faUndo,
  faPhone,
  faPhoneAlt,
  faUsers,
  faItalic,
  faUnderline,
  faAddressBook,
  faFlag,
  faGlobe,
  faPencilAlt,
  faMoneyBill,
  faMinus,
  faBroom,
  faUser,
  faSignOutAlt,
  faLock,
  faFilter,
  faCheck,
  faBinoculars,
  faSpinner,
  faEnvelope,
  faDollarSign,
  faSave,
  faEdit,
  faFileInvoice,
  faUserPlus,
  faSearch,
  faArrowLeft,
  faTrash,
  faSortDown,
  faUserCircle,
  faAddressCard,
  faSortUp,
  faBan,
  faPlus,
  faCompass,
  faTimes,
  faUpload,
  faCalendarAlt,
  faLongArrowAltRight,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faFileExport,
  faStopwatch,
  faBars,
  faCertificate,
  faExternalLinkAlt,
  faKey,
  faFlagUsa,
  faStickyNote,
  faTable,
  faCalendar,
  faLink,
  faBookOpen,
  faPrint,
  faPercent,
  faClock,
  faHistory,
  faCircle,
  faFileImport,
  faUserCheck,
  faSync,
  faChevronCircleLeft,
  faCalculator,
  faWarehouse,
  faShareSquare,
  faLevelUpAlt,
  faUsersCog,
  faInfo,
  faWeightHanging,
  faClone,
  faEye,
  faEyeSlash,
  faBarcode
);
